import CustomError from "./CustomError";

export default class LicenseError extends CustomError {

    constructor(message: string) {
        super(message);
        this.name = new.target.name;
        Error.captureStackTrace(this, this.constructor);
    }
}